import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { Module, ModuleDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getModule(id: string): Observable<Module> {
        return this.httpClient.get<ModuleDto>(`api/v1/library/modules/${id}`).pipe(
            map((response) => new Module(response)),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
